import { inject, Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import * as CryptoJS from 'crypto-js';


@Injectable({
  providedIn: 'root'
})

export class AESService {

  public configService = inject(ConfigService);

  constructor() { }

  public encrypt(value: string): string {
    return CryptoJS.AES.encrypt(value, this.configService.getSecurityKey().trim()).toString();
  }

  public decrypt(textToDecrypt: string) {
    return CryptoJS.AES.decrypt(textToDecrypt, this.configService.getSecurityKey().trim()).toString(CryptoJS.enc.Utf8);
  }

  public criptogrfaSenha(senha: string): string {
    return CryptoJS.HmacSHA256.encrypt(senha, this.configService.getSecurityKey().trim()).toString();
  }
}
